import { ShoppingCart, User } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const Navbar = () => {
  const { count, setIsOpen } = useCart();
  const { user } = useAuth();

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#090D16]/80 backdrop-blur-xl border-b border-slate-800/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" data-testid="nav-logo-link" aria-label="Gelvaro home">
          <Logo compact />
        </a>
        <nav className="hidden sm:flex items-center gap-8 text-sm font-semibold text-slate-300">
          <a href="/#blasters" data-testid="nav-link-blasters" className="hover:text-[#00FF66] transition-colors">
            Blasters
          </a>
          <a href="/abonnementen" data-testid="nav-link-abonnementen" className="hover:text-[#00FF66] transition-colors">
            Abonnementen
          </a>
          {user?.role === "admin" && (
            <a href="/admin" data-testid="nav-link-admin" className="text-[#FF087B] hover:text-white transition-colors">
              Beheer
            </a>
          )}
          <a href="/#waarom" data-testid="nav-link-waarom" className="hover:text-[#00FF66] transition-colors">
            Waarom Gelvaro
          </a>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="/account"
            data-testid="nav-account-button"
            className="flex items-center gap-2 bg-slate-800/80 hover:bg-slate-700 border border-slate-700 hover:border-[#00E5FF]/50 text-white font-bold px-4 py-2 rounded-full transition-all text-sm"
          >
            <User className="w-4 h-4" />
            <span className="hidden sm:inline">{user ? user.name.split(" ")[0] : "Inloggen"}</span>
          </a>
          <button
            data-testid="nav-cart-button"
            onClick={() => setIsOpen(true)}
            className="relative flex items-center gap-2 bg-slate-800/80 hover:bg-slate-700 border border-slate-700 hover:border-[#00FF66]/50 text-white font-bold px-4 py-2 rounded-full transition-all"
          >
            <ShoppingCart className="w-4 h-4" />
            <span className="hidden sm:inline text-sm">Winkelmand</span>
            {count > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -top-2 -right-2 bg-[#FF087B] text-white text-xs font-extrabold w-5 h-5 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
